'use client';
function isSameMonth(date, comparison) {
  return date.getFullYear() === comparison.getFullYear() && date.getMonth() === comparison.getMonth();
}

export { isSameMonth };
//# sourceMappingURL=is-same-month.mjs.map
